<template>
<div>

{{this.scenarioSetIn}}
    <!-- <el-collapse v-model="activeName" >

      <el-collapse-item title="Core Components" name="2"> -->

      <el-row v-for="(item,index) in this.scenarioSetIn.subsets">
        <el-col :span="1">
          <el-button-group>
            <el-button  size="mini" type="primary" icon="el-icon-sort-down" circle></el-button>
            <el-button  size="mini" type="primary" icon="el-icon-sort-up" circle></el-button>
          </el-button-group>
        </el-col>

        <el-col v-if="item.type=='Models'" :span="23"><div class="grid-content bg-purple-dark">{{item.name}}</el-button></div></el-col>

        <el-col v-if="item.type=='Computed'" :span="5"><div class="grid-content bg-purple">
          <el-input placeholder="Computed Variable Name" v-model='item.name'></el-input>



        </div></el-col>
        <el-col v-if="item.type=='Computed'" :span="4"><div class="grid-content bg-purple">
          <el-select v-model="item.CompComponents[0]" placeholder="Select">
            <el-option-group
              v-for="group in options"
              :key="group.label"
              :label="group.label">
              <el-option
                v-for="item in SelectableSubsets"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-option-group>
          </el-select>


        </div></el-col>
        <el-col v-if="item.type=='Computed'" :span="4"><div class="grid-content bg-purple-light">

          <el-radio-group v-model="item.CompFunction[0]">
            <el-radio-button label="+" value=1></el-radio-button>
            <el-radio-button label="-" value=2></el-radio-button>
            <el-radio-button label="*" value=3></el-radio-button>
            <el-radio-button label="/" value=4></el-radio-button>
          </el-radio-group>

        </div></el-col>
        <el-col v-if="item.type=='Computed'" :span="4"><div class="grid-content bg-purple">

          <el-select v-model="item.CompComponents[1]" placeholder="Select">
            <el-option-group
              v-for="group in options"
              :key="group.label"
              :label="group.label">
              <el-option
                v-for="item in SelectableSubsets"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-option-group>
          </el-select>

        </div></el-col>


      </el-row>


      <!-- </el-collapse-item>




    </el-collapse> -->




</div>


</template>
<style>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #003950;
  }
  .bg-purple {
    background: #00395096;
  }
  .bg-purple-light {
    background: #00395052;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>
<script>
import CanvasOmniBlock from '@/components/Canvas/Canvas-Omni-Block.vue'

export default {
  name: 'CanvasScenarioSettings',
  components: {
    CanvasOmniBlock

  },
  props: {
    scenarioSetIn: {

    }
  },
  data: function () {
    return {
        SetOptionsDialog: false,
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        activeName: 2,
        SetInputOutput: [],
        options: [{
          label: 'Popular cities',
          options: [{
            value: 'Shanghai',
            label: 'Shanghai'
          }, {
            value: 'Beijing',
            label: 'Beijing'
          }]
        }, {
          label: 'City name',
          options: [{
            value: 'Chengdu',
            label: 'Chengdu'
          }, {
            value: 'Shenzhen',
            label: 'Shenzhen'
          }, {
            value: 'Guangzhou',
            label: 'Guangzhou'
          }, {
            value: 'Dalian',
            label: 'Dalian'
          }]
        }],
        value: ''
    }
  },
  methods: {
  },
  computed: {
    SelectableSubsets () {

      var subsets=[];

      for(let ss=0; ss<this.scenarioSetIn.subsets.length; ss++){

        subsets.push({value:this.scenarioSetIn.subsets[ss].id,label:this.scenarioSetIn.subsets[ss].name})

      }

      return subsets


    }

  }
}
</script>
